export class KafkaSourceConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bootstrapServers",
            "baseName": "bootstrapServers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "topic",
            "baseName": "topic",
            "type": "string",
            "format": ""
        },
        {
            "name": "consumerGroupId",
            "baseName": "consumerGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "startingOffset",
            "baseName": "startingOffset",
            "type": "KafkaStartingOffset",
            "format": ""
        },
        {
            "name": "messageFormat",
            "baseName": "messageFormat",
            "type": "KafkaMessageFormat",
            "format": ""
        },
        {
            "name": "keyHandling",
            "baseName": "keyHandling",
            "type": "KafkaKeyHandling",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSourceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
